var lastId = 1;

class LayerLegendItem {

    /**
     * 
     * @param {*} options {
     *  color: String, 
     *  description: String, 
     *  icon: String ('circle' | 'rectangle'), 
     *  legend: LayerLegend, 
     *  isAssociatedWithFeature: (function(ol.Feature): boolean),
     * }
     */
    constructor(options){
        this.id = lastId++;
        this.color = options.color;
        this.description = options.description;
        this.icon = options.icon;
        this.legend = options.legend;
        this.isAssociatedWithFeature = options.isAssociatedWithFeature;
    }

    findAssociatedFeatures = () => {
        if(!this.isAssociatedWithFeature){
            return undefined;
        }

        return this.legend.layer.olLayer.getSource().getFeatures()
            .filter(feature => this.isAssociatedWithFeature(feature));
    }
}

export default LayerLegendItem;
